import request from "../../../core/wrappers/axios-wrapper";
import { ApiURL } from "../../../types/constants/apiUrls/api-urls";
import { RequestType } from "../../../types/enums/request-enums";

const ListMobileAppClientTranslations=(params:any)=>request({
    url: ApiURL.Query.GetListMobilePanelClientTranslations+"?countryId="+ params.countryId +"&culture=" +params.culture,
    method: RequestType.GET,
   });

const GetSupportedCulturesByCountryId=(params:any)=>request({
    url: ApiURL.Query.GetSupportedCulturesByCountryId+"?countryId="+params.countryId,
    method: RequestType.GET,
   });

   const MobileClientTranslationsQuery = {
    ListMobileAppClientTranslations,
    GetSupportedCulturesByCountryId
  };
  
  export default MobileClientTranslationsQuery;